module.exports = __webpack_public_path__ + "static/media/knex.47ebdbaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/knex.png
// module id = 114
// module chunks = 0